import {
  Link as TanstackLink,
  LinkProps as TanstackLinkProps,
} from "@tanstack/react-router";
import { ReactNode } from "react";
interface LinkProps extends TanstackLinkProps {
  className?: string;
  children: ReactNode;
}
export const Link = ({ children, ...props }: LinkProps) => {
  return <TanstackLink {...props}>{children}</TanstackLink>;
};
